import { inject, injectable } from "inversify";
import { ClientSelectRequestModel, GuidSelectModel, ICPLClientsClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientsService {
  getSelectModels(filter?: ClientSelectRequestModel): Promise<GuidSelectModel[]>;
}

@injectable()
export class ClientsService implements IClientsService {
  @inject(SERVICE_TYPES.CPLClientsClient) cplClientsClient!: ICPLClientsClient;

  async getSelectModels(filter?: ClientSelectRequestModel): Promise<GuidSelectModel[]> {
    return this.cplClientsClient.getSelectModels(filter);
  }
}
